import { Modal, Button, Form } from "react-bootstrap";
import { usePAChecklist } from "../pa_checklist_context";
import styles from '../pa_checklist.module.scss'
import { isNullish } from "../../../../utils/misc_utils";
import Select from 'react-select';
import { useEffect, useState } from "react";

const PAChecklistSubModalCaixa = () => {
  const { subModalCaixa, listaDefeitosComp, abrirModalInformacoes, itemEmAnaliseCaixa, setItemEmAnaliseCaixa, setSubModalCaixa, formularioCaixa, setFormularioCaixa, setListaProducoesRomaneioSelecionado } = usePAChecklist();
  const [indexAtivo, setIndexAtivo] = useState(0);

  useEffect(() => {
    setIndexAtivo(itemEmAnaliseCaixa.index);
  }, []);

  const customFilter = (option, searchText) => {
    if (!searchText) return true;
    return option.label.toLowerCase().includes(searchText.toLowerCase());
  }

  const fecharSubModal = () => {
    setItemEmAnaliseCaixa({});
    setSubModalCaixa(false);
  }

  const handleSetFormularioSimple = (field, value) => {
    const updatedFormulario = [...formularioCaixa];
    updatedFormulario[indexAtivo][field] = value;
    setFormularioCaixa([...updatedFormulario]);
  }

  const handleValueMask = (value) => {
    value = value ? value.replace(/[^0-9]/g, '') : '0';
    return (parseFloat(value) / 100).toFixed(2);
  }

  const handleSetFormularioDefeitos = (field, isKey, value) => {
    if (field === 'preco_tag_divergente' && !isKey) value = handleValueMask(value);

    const updatedFormulario = [...formularioCaixa];
    const newKey = !updatedFormulario[indexAtivo][field].key;
    updatedFormulario[indexAtivo][field] = { key: isKey ? newKey : updatedFormulario[indexAtivo][field].key, value }
    setFormularioCaixa([...updatedFormulario]);
  }

  return (
    <Modal
      show={subModalCaixa}
      centered
      size={'lg'}
      backdropClassName={styles.backdrop_z_override}
      onHide={() => setSubModalCaixa(false)}
      backdrop={'static'}
    >
      <Modal.Header style={{ fontWeight: '500' }}>
        Conferência de Caixa | NF: {itemEmAnaliseCaixa.nf_entrada} | Produto: {itemEmAnaliseCaixa.produto} | Cor: {itemEmAnaliseCaixa.cor_produto}
      </Modal.Header>
      <Modal.Body className={styles.modal_body}>
        <section className={styles.dados_analise_wrapper}>
          <div className={styles.dados_analise_divergencias}>
            <label className={styles.sub_form_label}><span>Peça Piloto Entregue?</span></label>
            <div className={styles.vertical_separator} />
            <span className={styles.sub_form_label}>{itemEmAnaliseCaixa.peca_piloto_entregue ? 'Sim' : 'Não'}</span>
          </div>

          <div className={styles.separator} />

          <div className={styles.dados_analise_divergencias}>
            <label className={styles.sub_form_label}>
              <span>A produção possui peça piloto?</span>
            </label>

            <div className={styles.vertical_separator} />

            <Form.Group className={styles.flex_options}>
              <Form.Check
                name={'peca_piloto'}
                id="peca_piloto_true"
                type={'radio'}
                label="Sim"
                checked={formularioCaixa[indexAtivo]?.possui_peca_piloto === true}
                onChange={() => handleSetFormularioSimple('possui_peca_piloto', true)}
                style={{ transform: 'scale(1.1)' }}
              />
              <Form.Check
                name={'peca_piloto'}
                id="peca_piloto_false"
                type={'radio'}
                label="Não"
                checked={formularioCaixa[indexAtivo]?.possui_peca_piloto === false}
                onChange={() => handleSetFormularioSimple('possui_peca_piloto', false)}
                style={{ transform: 'scale(1.1)' }}
              />
            </Form.Group>
          </div>

          <div className={styles.separator} />

          <div className={styles.btn_preco_wrapper}>
            <label className={styles.sub_form_label}>
              Preencha o campo abaixo se houver divergência entre os valores da TAG do produto e as informações do LINX
            </label>
            <label className={styles.sub_form_label}>
              <span>Preço LINX - R$ </span><span className={styles.font_blue_big}>{itemEmAnaliseCaixa.preco_produto}</span>
            </label>

            <Form.Group className={styles.dados_analise_divergencias}>
              <Form.Check
                type={'switch'}
                style={{ transform: 'scale(1.8)', cursor: 'pointer' }}
                checked={formularioCaixa[indexAtivo]?.preco_tag_divergente.key || false}
                onChange={() => handleSetFormularioDefeitos('preco_tag_divergente', true, '')}
              />
              <Form.Control
                type={'text'}
                placeholder={'Preço Divergente TAG'}
                value={formularioCaixa[indexAtivo]?.preco_tag_divergente.value || ''}
                onChange={e => handleSetFormularioDefeitos('preco_tag_divergente', false, e.target.value)}
                style={{ minWidth: '150px', height: '38px', width: '33%' }}
                disabled={!formularioCaixa[indexAtivo]?.preco_tag_divergente.key}
                isInvalid={
                  parseFloat(formularioCaixa[indexAtivo]?.preco_tag_divergente.value) === parseFloat(itemEmAnaliseCaixa.preco_produto)
                  || (formularioCaixa[indexAtivo]?.preco_tag_divergente.key && isNullish(formularioCaixa[indexAtivo]?.preco_tag_divergente.value))
                }
              />
            </Form.Group>
          </div>

          <div className={styles.separator} />

          <div className={styles.btn_preco_wrapper}>
            <label className={styles.sub_form_label}>
              Preencha o campo abaixo se houver divergência entre as composições na TAG do produto e as informações do LINX
            </label>
            <label className={styles.sub_form_label}>
              Composição LINX - <span className={styles.font_blue_big}>{itemEmAnaliseCaixa.composicao}</span>
            </label>

            <Form.Group className={styles.dados_analise_divergencias}>
              <Form.Check
                type={'switch'}
                style={{ transform: 'scale(1.8)', alignSelf: 'center', cursor: 'pointer' }}
                checked={formularioCaixa[indexAtivo]?.composicao_tag_divergente.key || false}
                onChange={() => handleSetFormularioDefeitos('composicao_tag_divergente', true, null)}
              />
              <Select
                className={styles.select_comp}
                placeholder={'Defeitos Composição'}
                value={formularioCaixa[indexAtivo]?.composicao_tag_divergente.value || null}
                onChange={e => handleSetFormularioDefeitos('composicao_tag_divergente', false, e)}
                options={listaDefeitosComp}
                filterOption={customFilter}
                isDisabled={!formularioCaixa[indexAtivo]?.composicao_tag_divergente.key}
                styles={{
                  control: base => ({
                    ...base,
                    borderColor: formularioCaixa[indexAtivo]?.composicao_tag_divergente.key && !formularioCaixa[indexAtivo]?.composicao_tag_divergente.value ? 'red' : base.borderColor,
                    '&:hover': {
                      borderColor: formularioCaixa[indexAtivo]?.composicao_tag_divergente.key && !formularioCaixa[indexAtivo]?.composicao_tag_divergente.value ? 'red' : base['&:hover'].borderColor
                    }
                  })
                }}
              />
            </Form.Group>
          </div>

          <div className={styles.separator} style={{ margin: '10px 0px' }} />

          <div>
            <label className={styles.sub_form_label} style={{ marginBottom: '16px', textAlign: 'center' }}>Localização Peça Piloto</label>
            {
              itemEmAnaliseCaixa.localizacoes_piloto?.length === 0 &&
              <div style={{ fontWeight: '500', textAlign: 'center' }}>
                Não há dados de localização da piloto no momento
              </div>
            }
            {
              itemEmAnaliseCaixa.localizacoes_piloto?.length > 0 &&
              itemEmAnaliseCaixa.localizacoes_piloto?.map((item, index) => {
                return (
                  <span key={`loc_p_p_${index}`}>
                    <span style={{ fontWeight: '500' }}>{item.localizacao} |</span>&nbsp;
                    <span style={{ fontWeight: '500' }}>{item.estoque} | Produto tal qual:</span>&nbsp;
                    <span style={{ fontWeight: '500' }}>{item.produto_tq || '-'}</span>
                  </span>
                );
              })}
          </div>
        </section>
      </Modal.Body>
      <Modal.Footer className={styles.modal_footer}>
        <Button
          variant={'secondary'}
          className={styles.footer_btn_processamento}
          style={{ width: '50% !important' }}
          onClick={() => fecharSubModal()}
        >
          Confirmar e Voltar
        </Button>

        <Button
          variant={'primary'}
          className={styles.footer_btn_processamento}
          style={{ width: '50% !important' }}
          onClick={() => abrirModalInformacoes(itemEmAnaliseCaixa)}
        >
          Informações
        </Button>
      </Modal.Footer>
    </Modal>
  );
}

export default PAChecklistSubModalCaixa;
